import {
  createMedicalInformationFormGroup,
  MedicalInformation,
} from '../../_lib/medical-info.js';
import { NonNullableFormBuilder } from '@angular/forms';

export enum UserRole {
  User = 'user',
  Administrator = 'administrator',
  Superuser = 'superuser',
}

export enum StaffRole {
  Office = 'office',
  Monitor = 'monitor',
  HeadMonitor = 'headMonitor',
  Teacher = 'teacher',
  External = 'external',
  RegionalManager = 'regionalManager',
  Billing = 'billing',
}

export enum AdminRole {
  Office = 'office',
  Billing = 'billing',
}

export enum ClothingSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  '2XL' = '2XL',
  '3XL' = '3XL',
  '4XL' = '4XL',
}

export enum InviteStatus {
  Pending = 'pending',
  Success = 'success',
  Failed = 'failed',
}

export interface CampStaffRoleInformation {
  medicalInformation: MedicalInformation;
  clothingSize: ClothingSize;
  isStudent: boolean;
}

export interface MonitorRoleInformation extends CampStaffRoleInformation {
  minecraftId?: string;
}

export interface HeadMonitorRoleInformation extends CampStaffRoleInformation {}

export type RoleInformation = Partial<MonitorRoleInformation> &
  Partial<HeadMonitorRoleInformation>;

export const createRoleInformationFormGroup = (fb: NonNullableFormBuilder) => {
  return fb.group({
    medicalInformation: createMedicalInformationFormGroup(fb),
    clothingSize: fb.control(ClothingSize.M),
    minecraftId: fb.control(''),
    isStudent: fb.control(false),
  });
};
